<template>
  <div
    v-if="resolvedSummary"
    class="subscription-usage"
    :class="{
      'error--text': overLimit,
      'subscription-usage--dense': dense,
      'subscription-usage--compact': compact
    }"
    role="status"
    aria-live="polite"
    :title="$t('message.subscriptionDetails.usageLabel')"
  >
    <span v-if="!compact" class="subscription-usage__label">
      {{
        $t(
          selectedCount
            ? "message.subscriptionDetails.projectedUsage"
            : "message.subscriptionDetails.usageLabel"
        )
      }}
    </span>
    <strong>{{ used }} / {{ limitLabel }}</strong>
    <span v-if="!compact && overLimit" class="subscription-usage__error">
      <slot name="limit-exceeded">{{
        $t(limitExceededMessageKey, { settings: $t("message.subscriptionDetails.subscriptionSettings") })
      }}</slot>
    </span>
  </div>
</template>

<script>
import {
  projectedUsage,
  isOverSubscriptionLimit
} from "@/helpers/subscription-usage";

export default {
  props: {
    subscriptionSummary: {
      type: Object,
      default: undefined
    },
    selectedCount: { type: Number, default: 0 },
    dense: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    limitExceededMessageKey: {
      type: String,
      default: "message.subscriptionDetails.importLimitExceeded"
    }
  },
  computed: {
    resolvedSummary() {
      return this.subscriptionSummary === undefined
        ? this.$store.getters["company/subscriptionSummary"]
        : this.subscriptionSummary;
    },
    used() {
      return projectedUsage(this.resolvedSummary, this.selectedCount);
    },
    overLimit() {
      return isOverSubscriptionLimit(this.resolvedSummary, this.selectedCount);
    },
    limitLabel() {
      if (this.resolvedSummary.limit === -1) return "∞";
      return this.resolvedSummary.limit == null
        ? "—"
        : this.resolvedSummary.limit;
    }
  }
};
</script>

<style lang="scss" scoped>
.subscription-usage {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 16px;
  strong {
    font-size: 24px;
    white-space: nowrap;
  }
  &__error {
    flex-basis: 100%;
  }
  &--compact {
    display: inline-flex;
    strong {
      font-size: inherit;
      font-weight: 500;
    }
  }
  &--dense {
    font-size: 14px;
    gap: 4px 8px;
    strong {
      font-size: 16px;
    }
  }
}
</style>
